/** Troca a origem de um link do Storage (ex: http://kong:8000 do Supabase local) pela origem base. Outros links passam direto. */
export function trocarOrigemStorage(link: string, base: string | undefined, origemPagina = "http://localhost"): string {
  if (!base) return link;
  try {
    const l = new URL(link, origemPagina);
    const b = new URL(base);
    if (l.pathname.includes("/storage/v1/") && l.origin !== b.origin) return `${base.replace(/\/$/, "")}${l.pathname}${l.search}`;
  } catch {
    return link;
  }
  return link;
}
